import React, {Fragment, PropsWithChildren} from 'react';
import {css} from '@mui/material/styles';
import {Box} from '@mui/material';
import styled from '@emotion/styled';
import mainBg from 'assets/img/mainWrapperBgImage.png';
import {transientOptions} from 'data/utils';

export const MainWrapper = styled(Box)`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	font-family: var(--fontFamilyBase);
	font-size: 16px;
	color: #fff;
`;

const withBgStyles = css`
	background: url("${mainBg}") no-repeat;
	background-position: center;
	background-size: cover;
`;
const bgStyles = css`
	background:url("${mainBg}") no-repeat 50% 0;
	background-size: auto;
`;
const resultedStyles = css`
	background: #f0f0f0;
`;

export const MainBox = styled(Box, transientOptions)<{
	$withBg: boolean;
	$bgStyle: boolean;
	$isResulted: boolean;
}>`
	flex: 1;
	width: 100%;
	color: #000;

	${({$withBg}) => $withBg && withBgStyles}
	${({$bgStyle}) => $bgStyle && bgStyles}
	${({$isResulted}) => $isResulted && resultedStyles}
  
  &.full-screen {
		display: flex;
		flex-direction: column;
	}
`;

export const StickyBox = styled(Box)`
	position: sticky;
	top: 0;
`;

const Link = styled.a`
	display: flex;
	justify-content: center;
`;

interface ISponsorWrapper {
	link?: string;
}

export const SponsorWrapper: React.FC<PropsWithChildren<ISponsorWrapper>> = ({link, children}) => {
	if (link && link.length) {
		return (
			<Link href={link} target="_blank" rel="noreferrer noopener">
				{children}
			</Link>
		);
	}

	return <Fragment>{children}</Fragment>;
};
